import * as React from "react";
import { useState } from "react";
import styled from "styled-components";
import { MarkdownPreview } from "components/common/MarkdownEditor";
const StyledCode = styled.code`
  background-color: transparent;
  color: ${({ theme }) => theme.colors.text.secondary};
  cursor: ${({ $disabled }) => $disabled ? "default" : "pointer"};

  &:hover {
    color: ${({ theme, $disabled }) => $disabled ? theme.colors.text.secondary : theme.colors.text.primary};
  }
`;
const MarkdownWrapper = styled.div`
  cursor: pointer;
`;
function DescriptionCell({ mdValue }) {
  const [showFormatted, setShowFormatted] = useState(false);
  const stringMaxLength = 100;
  if (!mdValue)
    return /* @__PURE__ */ React.createElement(StyledCode, { $disabled: true }, /* @__PURE__ */ React.createElement("i", null, "No description set"));
  return showFormatted ? /* @__PURE__ */ React.createElement(MarkdownWrapper, { onClick: () => setShowFormatted(false) }, /* @__PURE__ */ React.createElement(MarkdownPreview, { show: true, maxHeight: 500, noBackground: true, noBorder: true, value: mdValue, noPadding: true })) : /* @__PURE__ */ React.createElement(StyledCode, { onClick: () => setShowFormatted(true) }, `${mdValue.slice(0, stringMaxLength)}${mdValue.length >= stringMaxLength ? "..." : ""}`);
}
export default DescriptionCell;
